import { render, staticRenderFns } from "./PageWorkoutLogHome.vue?vue&type=template&id=234046fa&scoped=true"
import script from "./PageWorkoutLogHome.vue?vue&type=script&lang=js"
export * from "./PageWorkoutLogHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234046fa",
  null
  
)

export default component.exports